export const CARDS_MASK_FORMAT: string = '____ ____ ____ ____ ____ _'
export const CARDS_MASK: Array<string | RegExp> = toMask(CARDS_MASK_FORMAT)

/* '5555 5555 5555 5555' => '5555555555555555' */
export function cardNumberToServerValidValue(cardNumber: string): string {
    if (!cardNumber) return
    const INVALID_SYMBOLS_REGEXP: RegExp = /[\s_-]/g
    return cardNumber.replace(INVALID_SYMBOLS_REGEXP, '')
}

/* '5555555555555555' => '5555 5555 5555 5555' */
export function cardNumberToFrontFormattedValue(cardNumber: string): string {
    let result = CARDS_MASK_FORMAT

    cardNumberToServerValidValue(cardNumber)
        .split('')
        .forEach(symbol => {
            result = result.replace('_', symbol)
        })

    /* карта может быть короче 16ти символов */
    result = result.replace(/_/g, '')

    return result.trim()
}

export const PHONE_MASK_FORMAT: string = '+7(___) ___-__-__'
export const PHONE_MASK: Array<string | RegExp> = toMask(PHONE_MASK_FORMAT)

/* '+7(999) 999-99-99' => '+79999999999' */
export function phoneToServerValidValue(phone: string): string {
    const INVALID_SYMBOLS_REGEXP: RegExp = /-|\(|\)|\s/g
    return phone.replace(INVALID_SYMBOLS_REGEXP, '')
}

/* '+79999999999' => '+7(999) 999-99-99' */
export function phoneToFrontFormattedValue(phone: string): string {
    let result = PHONE_MASK_FORMAT
        .split('')
        .reverse()
        .join('')

    phoneToServerValidValue(phone)
        .split('')
        .reverse()
        .forEach(symbol => {
            result = result.replace('_', symbol)
        })

    return result
        .split('')
        .reverse()
        .join('')
}

export function toMask(format: string): Array<string | RegExp> {
    return format.split('').map(symbol => {
        switch (symbol) {
            default:
                return symbol
            case '_':
                return /\d/
        }
    })
}
